import { createFileRoute } from '@tanstack/react-router';
import { partnerStaticData } from '../../partner';

export const Route = createFileRoute('/_private-routes/partner/$id/')({
  staticData: partnerStaticData
});
